import {useMutation, useQueryClient} from '@github-ui/react-query'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {
  applyCopilotReviewEffortResponse,
  captureCopilotReviewEffort,
  collectCopilotReviewEffort,
} from '@github-ui/pull-request-page-data-tooling/copilot-review-effort'
import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
  parseJSONWithBetterErrors,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'

import {useMergeBoxPageDataQueryKey} from '../../page-data/loaders/use-merge-box-page-data'

export function useMarkReadyForReviewMutation({
  onError,
  onSuccess,
}: {onError?: (error: Error) => void; onSuccess?: () => void} = {}) {
  const apiURL = usePageDataUrl(PageData.markReadyForReview)
  const mergeBoxQueryKey = useMergeBoxPageDataQueryKey()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const picker = document.querySelector('[data-copilot-deferred-review-effort-picker]')
      const submission = captureCopilotReviewEffort(picker)
      const reviewEffort = collectCopilotReviewEffort(picker)
      const response = await fetchWithErrorHandling(apiURL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: reviewEffort,
      })
      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      applyCopilotReviewEffortResponse(submission, json)
      return json
    },
    onSuccess: () => {
      onSuccess?.()
      return queryClient.invalidateQueries({queryKey: mergeBoxQueryKey}, {cancelRefetch: false})
    },
    onError: (e: Error) => onError?.(e),
  })
}
